import { Link } from "react-router-dom";
import { useLang } from "@/context/LanguageContext";
import { siteConfig } from "@/data/siteConfig";
import { sentenceCase } from "@/lib/text";

export const Footer = () => {
  const { lang, t } = useLang();

  const navLinks = [
    { to: `/${lang}`, label: t.nav.home, id: "home" },
    { to: `/${lang}/about`, label: t.nav.about, id: "about" },
    { to: `/${lang}/services`, label: t.nav.services, id: "services" },
    { to: `/${lang}/team`, label: t.nav.team, id: "team" },
    { to: `/${lang}/el-salvador-ee-uu`, label: t.nav.diaspora, id: "diaspora" },
    { to: `/${lang}/contact`, label: t.nav.contact, id: "contact" },
  ];

  return (
    <footer className="bg-navy text-white" data-testid="site-footer">
      <div className="max-w-7xl mx-auto px-6 md:px-12 py-16 md:py-20">
        <div className="grid grid-cols-1 md:grid-cols-12 gap-12">
          <div className="md:col-span-5">
            <div className="mb-8">
              <img src={lang === "es" ? siteConfig.logoFooterEs : siteConfig.logoFooter} alt={t.brandName} className="h-20 w-auto" />
            </div>
            <p className="text-white/60 text-sm leading-relaxed max-w-sm">{t.footer.tagline}</p>
            <p className="text-white/40 text-xs mt-6">{siteConfig.domain}</p>
          </div>

          <div className="md:col-span-3">
            <h3 className="text-xs uppercase tracking-[0.2em] text-white/50 mb-5">{t.footer.navTitle}</h3>
            <ul className="space-y-3">
              {navLinks.map((l) => (
                <li key={l.id}>
                  <Link
                    to={l.to}
                    className="text-sm text-white/80 hover:text-ser-blue transition-colors"
                    data-testid={`footer-nav-${l.id}-link`}
                  >
                    {l.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div className="md:col-span-2">
            <h3 className="text-xs uppercase tracking-[0.2em] text-white/50 mb-5">{t.footer.servicesTitle}</h3>
            <ul className="space-y-3">
              {t.services.slice(0, 6).map((s) => (
                <li key={s.id}>
                  <Link
                    to={`/${lang}/services/${s.id}`}
                    className="text-sm text-white/80 hover:text-ser-blue transition-colors"
                  >
                    {sentenceCase(s.name)}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div className="md:col-span-2">
            <h3 className="text-xs uppercase tracking-[0.2em] text-white/50 mb-5">{t.footer.contactTitle}</h3>
            <ul className="space-y-3">
              {siteConfig.emails.map((e) => (
                <li key={e.key}>
                  <a href={`mailto:${e.address}`} className="text-sm text-white/80 hover:text-ser-blue transition-colors" data-testid={`footer-email-${e.key}`}>
                    {e.address}
                  </a>
                  <span className="block text-xs text-white/40">{e.label[lang]}</span>
                </li>
              ))}
            </ul>
            <div className="mt-6">
              <Link to={`/${lang}/privacy`} className="text-sm text-white/60 hover:text-white transition-colors" data-testid="footer-privacy-link">
                {t.footer.privacy}
              </Link>
            </div>
          </div>
        </div>

        <div className="mt-14 pt-8 border-t border-white/10 flex flex-col md:flex-row md:items-center md:justify-between gap-3">
          <p className="text-xs text-white/50">{t.footer.rights}</p>
          <p className="text-xs text-white/40">{t.footer.dba}</p>
        </div>
      </div>
    </footer>
  );
};
